import { render, staticRenderFns } from "./QuoteFollowup.vue?vue&type=template&id=57f983bf&scoped=true"
import script from "./QuoteFollowup.vue?vue&type=script&lang=js"
export * from "./QuoteFollowup.vue?vue&type=script&lang=js"
import style0 from "./QuoteFollowup.vue?vue&type=style&index=0&id=57f983bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f983bf",
  null
  
)

export default component.exports